import { createEvent } from '@cobuildlab/react-simple-state';
import { UserMetaApiAccount } from '../user/user-types';
import { User } from '../../shared/types/generated';

export interface InitialStateType {
  token: null | string;
}

const INITIAL_STATE = {
  token: null,
};

export const OnTokenEvent = createEvent<InitialStateType>({
  initialValue: INITIAL_STATE,
});
export const OnTokenErrorEvent = createEvent<Error>();

export const fetchUserEvent = createEvent<{ user?: User, metaApiAccount?: UserMetaApiAccount }>({
  initialValue: { user: undefined },
});

export const fetchUserErrorEvent = createEvent<Error>();
